import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIconMicrosoft3652022 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 76 75'
    {...props}
  >
    <path
      fill='url(#Icon_Microsoft_365_2022_svg__a)'
      d='m31.669 5.161-.347.21q-.827.5-1.554 1.113l.999-.703h8.479l1.541 11.672-7.707 7.707-7.707 5.357v6.177c0 4.315 2.255 8.316 5.946 10.55l8.113 4.911-17.142 10h-3.306l-6.162-3.73a12.33 12.33 0 0 1-5.946-10.55V27.103c0-4.316 2.256-8.318 5.949-10.551L31.322 5.363q.172-.105.347-.202'
    />
    <path
      fill='url(#Icon_Microsoft_365_2022_svg__b)'
      d='m31.669 5.161-.347.21q-.827.5-1.554 1.113l.999-.703h8.479l1.541 11.672-7.707 7.707-7.707 5.357v6.177c0 4.315 2.255 8.316 5.946 10.55l8.113 4.911-17.142 10h-3.306l-6.162-3.73a12.33 12.33 0 0 1-5.946-10.55V27.103c0-4.316 2.256-8.318 5.949-10.551L31.322 5.363q.172-.105.347-.202'
    />
    <path
      fill='url(#Icon_Microsoft_365_2022_svg__c)'
      d='M50.036 29.784v6.906c0 4.315-2.255 8.316-5.946 10.55L25.593 58.436a12.33 12.33 0 0 1-12.343.248L31.32 69.621a12.33 12.33 0 0 0 12.771 0l18.497-11.196a12.33 12.33 0 0 0 5.946-10.55v-4.989l-1.541-2.312z'
    />
    <path
      fill='url(#Icon_Microsoft_365_2022_svg__d)'
      d='M50.036 29.784v6.906c0 4.315-2.255 8.316-5.946 10.55L25.593 58.436a12.33 12.33 0 0 1-12.343.248L31.32 69.621a12.33 12.33 0 0 0 12.771 0l18.497-11.196a12.33 12.33 0 0 0 5.946-10.55v-4.989l-1.541-2.312z'
    />
    <path
      fill='url(#Icon_Microsoft_365_2022_svg__e)'
      d='M62.584 16.552 44.087 5.363A12.33 12.33 0 0 0 31.69 5.15l-.368.223a12.33 12.33 0 0 0-5.949 10.551v14.619l5.95-3.599a12.33 12.33 0 0 1 12.764 0l18.497 11.189a12.33 12.33 0 0 1 5.943 10.147q.006-.201.006-.404V27.103c0-4.316-2.256-8.318-5.949-10.551'
    />
    <path
      fill='url(#Icon_Microsoft_365_2022_svg__f)'
      d='M62.584 16.552 44.087 5.363A12.33 12.33 0 0 0 31.69 5.15l-.368.223a12.33 12.33 0 0 0-5.949 10.551v14.619l5.95-3.599a12.33 12.33 0 0 1 12.764 0l18.497 11.189a12.33 12.33 0 0 1 5.943 10.147q.006-.201.006-.404V27.103c0-4.316-2.256-8.318-5.949-10.551'
    />
    <defs>
      <radialGradient
        id='Icon_Microsoft_365_2022_svg__a'
        cx={0}
        cy={0}
        r={1}
        gradientTransform='rotate(110.528 7.923 18.002)scale(51.4312 89.7065)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.064} stopColor='#AE7FE2' />
        <stop offset={1} stopColor='#0078D4' />
      </radialGradient>
      <radialGradient
        id='Icon_Microsoft_365_2022_svg__c'
        cx={0}
        cy={0}
        r={1}
        gradientTransform='matrix(47.35265 -6.9647 4.60065 31.27957 16.787 56.53)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.134} stopColor='#D59DFF' />
        <stop offset={1} stopColor='#5E438F' />
      </radialGradient>
      <radialGradient
        id='Icon_Microsoft_365_2022_svg__e'
        cx={0}
        cy={0}
        r={1}
        gradientTransform='rotate(-165.772 34.577 16.682)scale(38.417 64.6713)'
        gradientUnits='userSpaceOnUse'
      >
        <stop offset={0.058} stopColor='#50E6FF' />
        <stop offset={1} stopColor='#436DCD' />
      </radialGradient>
      <linearGradient
        id='Icon_Microsoft_365_2022_svg__b'
        x1={27.703}
        x2={20.365}
        y1={58.869}
        y2={46.177}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#114A8B' />
        <stop offset={1} stopColor='#0078D4' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='Icon_Microsoft_365_2022_svg__d'
        x1={62.917}
        x2={55.054}
        y1={39.614}
        y2={50.889}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#493474' />
        <stop offset={1} stopColor='#8C66BA' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='Icon_Microsoft_365_2022_svg__f'
        x1={26.877}
        x2={38.455}
        y1={5.209}
        y2={5.209}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2D3F80' />
        <stop offset={1} stopColor='#436DCD' stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgIconMicrosoft3652022;
